import { createPrivate } from 'api/chat/private/create-private';
import { useSubscription } from 'hooks/use-subscription.hook';
import { ContactType } from 'pages/chat/consts';
import { useChatContext } from 'pages/chat/context';
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IUser } from 'types/chat';
interface Props {
  item: IUser;
}

const UserItem = (props: Props) => {
  const { item } = props;
  const avatarRef = useRef(null);
  const chatContext = useChatContext();
  const navigate = useNavigate();
  const subscription = useSubscription();

  const onLoadImgError = (srcImg) => {
    srcImg.current.src =
      // eslint-disable-next-line max-len
      'https://png.pngtree.com/png-vector/20191101/ourmid/pngtree-cartoon-color-simple-male-avatar-png-image_1934459.jpg';
  };

  const renderAvatar = () => {
    const avatarOtherUser =
      item.path_avatar ||
      // eslint-disable-next-line max-len
      'https://png.pngtree.com/png-vector/20191101/ourmid/pngtree-cartoon-color-simple-male-avatar-png-image_1934459.jpg';

    return (
      <div className='item-single-avatar'>
        <img src={avatarOtherUser} ref={avatarRef} alt='user icon' onError={() => onLoadImgError(avatarRef)} />
        <div className='item-status online'></div>
      </div>
    );
  };

  const onPairing = () => {
    const createPrivateSub = createPrivate(item._id).subscribe((res) => {
      if (res.data) {
        chatContext.getConversations();
        chatContext.setContactType(ContactType.CONVERSATION);

        navigate(`/chat/${res.data}`);
      }
    });

    subscription.add(createPrivateSub);
  };

  return (
    <div className='chat-item-wrapper' onClick={onPairing}>
      <>{renderAvatar()}</>
      <div className='item-content'>
        <div className='item-username'>
          <p>{item?.emp_name}</p>
        </div>
        <div className='item-message'></div>
      </div>

      <div className='item-date'></div>
    </div>
  );
};

export default UserItem;
